import { FC, memo } from 'react'

import { RegionsSectionTransport } from '../../../transports/region-landing-page-transport'
import VacationRegion from './vacation-region'

import { Container, RegionsGrid, RegionsColumnCard } from './styles'
import { Title, TitleContainer } from '../common/styles'

interface Props {
    regionsSection: RegionsSectionTransport
}

const VacationRegionsSection: FC<Props> = ({ regionsSection: { heading, regions } }) => {
    const mid = Math.ceil(regions.length / 2)
    const left = regions.slice(0, mid)
    const right = regions.slice(mid)
    const isOdd = regions.length % 2 === 1

    return (
        <Container id="vacation-regions">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <RegionsGrid>
                <RegionsColumnCard key="col-left">
                    {left.map((region, i) => (
                        <VacationRegion key={region.id} {...region} isLast={i === left.length - 1} />
                    ))}
                </RegionsColumnCard>
                {right.length > 0 && (
                    <RegionsColumnCard key="col-right">
                        {right.map((region, i) => (
                            <VacationRegion
                                key={region.id}
                                {...region}
                                isLast={i === right.length - 1}
                                forceBorder={isOdd && regions.length > 1 && i === right.length - 1}
                            />
                        ))}
                    </RegionsColumnCard>
                )}
            </RegionsGrid>
        </Container>
    )
}

export default memo(VacationRegionsSection)
